import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom, Observable, throwError } from 'rxjs';
import * as jwt_decode from 'jwt-decode';
import { OAuthService } from 'angular-oauth2-oidc';
import { StorageService } from '../services/storage.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from '../../codes/components/dialog/dialog.component';


@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {
    dialogTitle: string = "Session.Expired.dialogTitle";
    dialogText: string= "Session.Expired.dialogText";
     dialogButtonConfirm: string= "Session.Expired.dialogButtonConfirm";
   
    
    constructor(private oauthService: OAuthService, private injector: Injector, private _storageService: StorageService, private router: Router, public dialog: MatDialog) { }

    intercept(request: HttpRequest<any>, next: HttpHandler, retry = false): Observable<HttpEvent<any>> {
        let requestToForward = request;
        if (this.oauthService === undefined) {
            this.oauthService = this.injector.get(OAuthService);
        }
        let headers: HttpHeaders = request.headers;
        if (this.oauthService.discoveryDocumentLoaded && this.oauthService.hasValidAccessToken()) {
            let token = this.oauthService.getAccessToken();

            if (token && token !== "") {
                let tokenValue = "Bearer " + token;
                headers = headers.set('Authorization', tokenValue);
            }
        }
        console.debug(request)

        requestToForward = request.clone({
            headers
        });


        return next.handle(requestToForward).pipe(
            catchError( async (err: Error) => {
                if (err instanceof HttpErrorResponse && err.status === 401) {//here
                    if (this.oauthService.discoveryDocumentLoaded && !retry) {
                        await this.oauthService.tryLogin();
                        this.openDialog();
                        return firstValueFrom(this.intercept(requestToForward, next, true));
                    }
                }
                throw err;
            })
        );
    }

    openDialog():void{
        let dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          dialogTitle: this.dialogTitle,
          dialogText: this.dialogText,
          iscancel:false,
          dialogButtonConfirm: this.dialogButtonConfirm,
                };
        dialogConfig.position =  {
          top: '100px',
        };
        dialogConfig.minWidth = '640px';
    
        dialogConfig.minHeight = '201px';
        dialogConfig.maxWidth = '540px';
        let dialogRef = this.dialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this._storageService.clearStorage();
            this.oauthService.logOut();
          }
        });
      }

}